import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function EditTitleDialog({ open, onClose, currentTitle, onSave }) {
  const { t } = useTranslation();
  const [newTitle, setNewTitle] = useState(currentTitle);

  // Sync state with prop whenever the dialog opens or currentTitle changes
  useEffect(() => {
    if (open) {
      setNewTitle(currentTitle);
    }
  }, [open, currentTitle]);

  const handleSaveClick = () => {
    if (newTitle.trim()) {
      onSave(newTitle);
    } else {
      onSave(t("Untitled Schedule"));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("Edit Schedule Title")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="title"
          label={t("Schedule Title")}
          type="text"
          fullWidth
          variant="outlined"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("Cancel")}
        </Button>
        <Button onClick={handleSaveClick} color="secondary" variant="contained">
          {t("Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditTitleDialog;
